<template>
  <div>
    <div v-if='!isDetail' class="content-item">
      <div class="top">
        <div class="no">编号: {{ data.info.no || '-' }}</div>
        <div class="paimi">排名: {{data.paimin}}</div>
      </div>
      <div class="bottom">
        <div class="item-left" @click="handleGoDetail">
          <div class="item-left-img">
            <img :src="data.info.image+'?imageView2/1/w/400/h/300'"  alt="">
          </div>
          <div class="item-left-vote">
            {{ data.votes }} 票
          </div>
        </div>
        <div class="item-right">
          <div class="item-right-header">
            <div @click="handleGoDetail" class="item-right-title">{{ data.info.title }}</div>
            <div class="item-right-company">{{ data.info.cpdw }}</div>
          </div>
          <div class="item-right-footer">
            <div @click="handleVote" class="item-right-footer_btn"></div>
          </div>
        </div>
      </div>
      
    </div>
    <div v-if='isDetail' class="content-detail">
      <div class="detail-content">
        <img v-if='!isVideoDetail' :src='`${data.info.image}${data.info.image.indexOf("?") > -1 ? "&" : "?"}imageView2/2/w/640`' alt="">
        <video v-if='isVideoDetail' :src='data.info.video' controls='controls' loop='loop' :poster="`${data.info.image}?imageMogr2/thumbnail/!750x420r/gravity/Center/crop/750x420|imageslim`"></video>
      </div>
      <div class="detail-title-wrap">
        <div class="detail-vote-wrap">
          <span>{{ data.votes }}&nbsp;票</span>
        </div>
        <div class="detail-title">
          {{ data.info.title }}
        </div>
      </div>
      <div class="detail-footer">
        <div class="detail-desc">
          {{ data.info.intro }}
        </div>
        <div class="detail-btn">
          <span @click="handleGoBack" class="back-btn"></span>
          <span @click="handleVote" class="vote-btn"></span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

let openid = '';

export default {
  data() {
    return {
      user: {},
      isLoad: false
    }
  },
  props: ['data', 'origin', 'successCallback'],
  computed: {
    ...mapState(['userinfo', 'aid']),
    isDetail() {
      return this.origin === 'detail'
    },
    isVideoDetail() {
      return this.data && this.data.info && this.data.info.video
    },
	},
  methods: {
    ...mapActions([
      'setPageLoadingAsync',
      'Toast',
      'getUserinfoAsync',
      'setUserinfo',
      'setCurrentItemId',
    ]),
    handleGoDetail() {
      this.$router.push({
        path: `detail/${this.data.id}`
      });
      this.setCurrentItemId(this.data.id);
    },
    handleGoBack() {
      this.$router.push('/');
    },
    handleVote() {
      const _this = this;
      const userinfo = this.userinfo;
      console.log(userinfo)
      if (userinfo.token) {
        this.vote();
        return;
      }
      if (COVERAPP.Attribute.isApp()) {
        COVERAPP.Method.GetUser({
          callback(res) {
            let userinfo = JSON.parse(res);
            if(!COVER.isEmpty(userinfo.user_id)){
              userinfo.origin = 'app';
              if (COVERAPP.Attribute.isIOS()) {
                userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
              }
              
              _this.user = userinfo;
              _this.setUserinfo(userinfo);
              _this.vote();
            } else {
              COVERAPP.Method.OpenLogin({
                callback(res) {
                  let userinfo = JSON.parse(res);
                  if (!COVER.isEmpty(userinfo.user_id)) {
                    userinfo.origin = 'app';
                    if (COVERAPP.Attribute.isIOS()) {
                      userinfo.nickname = decodeURIComponent(escape(window.atob(userinfo.nickname)));
                    }

                    userinfo.app_token = userinfo.token;

                    _this.user = userinfo;
                    _this.setUserinfo(userinfo);
                    _this.vote();
                  }
                }
              });
            }
          }
        });
        return;
      }

      this.Toast({
        text: '请先登录'
      });
      this.getUserinfoAsync();
    },
    vote() {
      const vid = this.data.id;
      const userinfo = this.user.token ? this.user : this.userinfo;
      const token = userinfo.token || '';
      if (!token) {
        this.Toast({
          text: '请先登录'
        });
        return;
      }
      if (this.isLoad) {
        return;
      }
      console.log(userinfo)
      let param = {
        aid: this.aid,
				uid: token,
				vid: vid,
        userinfo: userinfo,
        // token: token,
      }
      if (COVERAPP.Attribute.isApp()) {
        const userid = userinfo.user_id;
        param.deviceid = COVERAPP.Attribute.deviceId();
        param.token = token;
        param.userid = userid;
        if (openid) {
          userinfo.openid = openid;
          param.openid = userid.toString(36) + '_' + openid + '_' + (+(new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date().getDate())).toString(36);
        }
      }

      // param.userinfo = JSON.stringify(userinfo);

      const loadtime = setTimeout(() => {
        this.isLoad = true;
      }, 1500);

      this.$request('/vote', 'post', param).then(res => {
        clearTimeout(loadtime);
        this.isLoad = false;
        console.log(JSON.stringify(res));
        if (res.errno === 0) {
          this.Toast({
            text: '投票成功'
          });
          if (this.isDetail) {
            this.data.votes++;
          }
          if (this.successCallback) {
            this.successCallback();
          }
          return;
        }

        // if (res.errno === 2028) {
        //   this.Toast({
        //     text: '今日次数已用完~'
        //   });
        //   return;
        // }

        // if (res.errno === 1021) {
        //   this.Toast({
        //     text: '您已向该候选投票，请投其他的~'
        //   });
        //   return;
        // }

        // if (res.errno === 1008) {
        //   this.Toast({
        //     text: '未开始'
        //   });
        //   return;
        // }

        // if (res.errno === 1009) {
        //   this.Toast({
        //     text: '已结束'
        //   });
        //   return;
        // }
        
        // 未绑定微信
        if (res.errno === 1250) {
          const isOpenid = confirm('该活动需要绑定微信');
          if (isOpenid) {
            COVERAPP.Method.wxAuthorize({
              callback(res) {
                const info = JSON.parse(res) || {};
                openid = info.openid || '';
              }
            });
          }
          return;
        }

        // if (res.errno === 1231) {
        //   alert('当前太火爆啦，请稍后再试吧~');
        //   return;
        // }

        // if (res.errno === 1251) {
        //   alert('当前微信账号已被其他账号关联，请使用被关联的账号投票');
        //   return;
        // }
        this.Toast({
          text: res.errmsg || '网络错误~'
        });
      }).catch(err => {
        clearTimeout(loadtime);
        this.isLoad = false;
      });
    }
  }
}
</script>

<style lang="less" scoped>

  .content-item {
    margin-bottom: 0.573333rem;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.32rem;
      color: #fff;
      .no {
        background: #000;
        padding: 0.1rem;
        padding-right: 0.4rem;
      }
      .paimi {
        font-size: 0.373333rem;
      }
    }
    .bottom {
      display: flex;
      height: 3.386666rem;
    }
  }
  .item-left {
    width: 44%;
    height: 100%;
    overflow: hidden;
    border: 2px solid #000;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    &-img {
      height: 2.3733333rem;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
      }
    }
    &-vote {
      height: 1.013333rem;
      background-color: #fff;
      font-size: 0.373333rem;
      text-align: center;
      box-sizing: border-box;
      border-top: 2px solid #000;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .item-right {
    width: 56%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 0.12rem;
    margin-left: 0.37333333rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .item-right-title, .item-right-company {
      font-size: 0.4266666rem;
      color: #FFD11C;
    }
    .item-right-title {
      line-height: 0.6rem;
      font-weight: 500;
      max-height: 1.1733333rem;
      overflow-y: scroll;
    }
    .item-right-company {
      font-size: 0.3733333rem;
      margin-top: 0.2666666rem;
      color: #FFFFFF;
    }
    .item-right-footer {
      display: flex;
      justify-content: flex-end;
      .item-right-footer_btn {
        background: url('../assets/img/tp-btn.png') no-repeat center top;
        background-size: 100%;
        width: 2.666666rem;
        height: 1.213333rem;
      }
    }
  }

  .content-detail {
    .detail-content {
      width: 100%;
      overflow: hidden;
      background-color: #eaeaea;
      position: relative;
      border: 2px solid #000;
      border-bottom: none;
      box-sizing: border-box;
      video {
        width: 100%;
        background-color: #000;
        height: 5.6rem;
      }
    }
    .detail-title-wrap {
      background-color: #fff;
      overflow: hidden;
      min-height: 1.6rem;
      display: flex;
      border: 2px solid #000;
      box-sizing: border-box;
      .detail-vote-wrap {
        width: 3.333333rem;
        background-color: #FF5847;
        font-size: .3733333rem;
        color: #fff;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-right: 2px solid #000;
      }
      .detail-title {
        font-size: .4266666rem;
        color: #000;
        font-weight: 700;
        flex: 1;
        display: flex;
        align-items: center;
        padding: 0.4rem 0.533333rem;
      }
    }
    .detail-footer {
       background: url('../assets/img/fill.png') no-repeat center top;
      background-size: 100%;
      min-height: 10.0266666rem;
      box-sizing: border-box;
      padding-bottom: 0.6rem;
    }
    .detail-desc {
      font-size: .4266666rem;
      color: #fff;
      padding: .601852rem .462963rem 1.601852rem .555556rem;
      line-height: 0.8rem;
      word-break: break-all;
    }
    .detail-btn {
      display: flex;
      justify-content: center;
    
      span {
        display: inline-block;
      }
      .back-btn {
        background: url('../assets/img/detail2.png') no-repeat center top;
        margin-right: 1.33333rem;
      }
      .vote-btn {
        background: url('../assets/img/detail1.png') no-repeat center top;
      }
      .back-btn, .vote-btn {
        width: 3.52rem;
        height: 1.6rem;
         background-size: 100%;
      }
    }
  }
</style>